import { useBreadcrumb } from '$components/Breadcrumb/hooks/useBreadcrumb'
import OTPSetting from '$components/OTPSetting'
import { useGlobalServiceUserService } from '$hooks/services'
import MainHeader from '$layouts/UserProfileLayout/components/MainHeader'
import { useProfileDataStore } from '$layouts/UserProfileLayout/hooks/useProfileDataStore'
import {
  innerMainContent,
  mainContent
} from '$layouts/UserProfileLayout/styles.css'
import { useCallback } from 'react'

const GlobalServiceUserSMSOTP = () => {
  const { fetchSMSOTP, fetchingSMSOTP, smsOTP } = useGlobalServiceUserService()
  const {
    id: userId,
    phone_code,
    phone_no
  } = useProfileDataStore(state => state.profile) ?? {}

  const hasPhone = !!phone_code && !!phone_no

  useBreadcrumb([{ name: 'SMS OTP' }])

  const onGetSMSOTP = useCallback(() => {
    if (!userId) return
    fetchSMSOTP({ userId })
  }, [userId, fetchSMSOTP])

  if (!hasPhone) {
    return (
      <article className={mainContent}>
        <article
          className={innerMainContent}
          style={{ height: 400, justifyContent: 'center' }}
        >
          <p style={{ textAlign: 'center', color: 'var(--text-color)' }}>
            No phone number is associated with this account.
          </p>
        </article>
      </article>
    )
  }

  return (
    <>
      <MainHeader
        title="SMS OTP"
        desc="Manage codes sent to the user's phone for account verification."
      />

      <article className={mainContent}>
        <article
          className={innerMainContent}
          style={{ gap: 40, paddingBottom: 80 }}
        >
          <OTPSetting
            title="Requested SMS OTP"
            loading={fetchingSMSOTP}
            onGetOTP={onGetSMSOTP}
            otpData={smsOTP}
          />
        </article>
      </article>
    </>
  )
}

export default GlobalServiceUserSMSOTP
